!function (e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("moment-timezone"), require("react"));else if ("function" === typeof define && define.amd) define(["moment-timezone", "react"], t);else {
    var r = "object" === typeof exports ? t(require("moment-timezone"), require("react")) : t(e["moment-timezone"], e.react);

    for (var n in r) {
      ("object" === typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function (e, t) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/", r(r.s = 0);
  }([function (e, t, r) {
    e.exports = r(1);
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(r(2));
    t.getBoardGroupNameLabel = o.default;
    var u = n(r(4));
    t.handleFetch = u.default;
    var a = n(r(7));
    t.depracated_handleFetch = a.default;
    var i = n(r(10));
    t.unifyDate = i.default;
    var c = n(r(12));
    t.PhyzziBrandLoader = c.default;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(r(3));

    t.default = function (e, t) {
      return "common:boardGroupName." + o.default(e, t);
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    t.default = function (e, t) {
      var r = e.filter(function (e) {
        return e.id === t;
      });
      return r.length > 0 ? r[0].string_id : "";
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(5);

    t.default = function (e, t) {
      var r,
          o = e.url,
          u = e.callbackArg;
      return fetch(o, n.getFetchConfig(e)).then(function (e) {
        return r = n.getCallback(e.status, t), n.extractResponseJson(e);
      }).then(function (e) {
        r && r(u || {}, e);
      });
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(6);
    t.getFetchConfig = function (e) {
      var t = e.method,
          r = e.token,
          o = e.body,
          u = n.config.credentials,
          a = n.config.mode,
          i = n.config.method,
          c = {
        credentials: u,
        mode: a,
        method: t || i,
        cache: n.config.cache,
        headers: n.config.headers
      };
      return r && (c.headers["X-CSRF-TOKEN"] = r), o && (c.body = JSON.stringify(o)), c;
    }, t.getCallback = function (e, t) {
      return t["code_" + e] ? t["code_" + e] : t["code_" + Math.floor(e / 100) + "xx"] ? t["code_" + Math.floor(e / 100) + "xx"] : e < 300 && t.success ? t.success : e >= 300 && t.error ? t.error : null;
    }, t.extractResponseJson = function (e) {
      var t = e.status;
      return t >= 200 && t < 300 ? e.json() : null;
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.config = {
      credentials: "include",
      mode: "cors",
      method: "GET",
      cache: "no-store",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(8);

    t.default = function (e, t) {
      var r,
          o = e.url;
      e.callbackArg;
      return fetch(o, n.getFetchConfig(e)).then(function (e) {
        return r = n.getCallback(e.status, t), n.extractResponseJson(e);
      }).then(function (e) {
        r && r(e);
      });
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(9);
    t.getFetchConfig = function (e) {
      var t = e.method,
          r = e.token,
          o = e.body,
          u = n.config.credentials,
          a = n.config.mode,
          i = n.config.method,
          c = {
        credentials: u,
        mode: a,
        method: t || i,
        cache: n.config.cache,
        headers: n.config.headers
      };
      return r && (c.headers["X-CSRF-TOKEN"] = r), o && (c.body = JSON.stringify(o)), c;
    }, t.getCallback = function (e, t) {
      return t["code_" + e] ? t["code_" + e] : t["code_" + Math.floor(e / 100) + "xx"] ? t["code_" + Math.floor(e / 100) + "xx"] : e < 300 && t.success ? t.success : e >= 300 && t.error ? t.error : null;
    }, t.extractResponseJson = function (e) {
      var t = e.status;
      return t >= 200 && t < 300 ? e.json() : null;
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.config = {
      credentials: "include",
      mode: "cors",
      method: "GET",
      cache: "no-store",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(r(11));

    t.default = function (e, t) {
      return void 0 === t && (t = "UTC"), o.default.tz(e, t);
    };
  }, function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(r(13)),
        u = n(r(14));
    r(15);
    var a = r(17);
    t.PhyzziBrandLoader = function (e) {
      var t = a.getComponentClassName(e),
          r = a.getWrapperClassName(e),
          n = a.getImageClassName(e);
      return o.default.createElement("div", {
        className: t
      }, o.default.createElement("section", {
        className: r
      }, o.default.createElement("img", {
        src: u.default.url,
        alt: "Phyzzi.com icon",
        className: n
      })));
    }, t.default = t.PhyzziBrandLoader;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.config = {
      url: "/img/logo/loader.svg"
    }, t.default = t.config;
  }, function (e, t, r) {},, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getComponentClassName = function (e) {
      return "PhyzziBrandLoader" + (e.modifier ? " " + e.modifier : "");
    }, t.getWrapperClassName = function (e) {
      return "PhyzziBrandLoader__image-wrapper" + (e.modifier ? " " + e.modifier : "");
    }, t.getImageClassName = function (e) {
      return "PhyzziBrandLoader__image" + (e.modifier ? " " + e.modifier : "");
    };
  }]);
});